import { render, staticRenderFns } from "./BruttoDiffTable.vue?vue&type=template&id=1086a61f"
import script from "./BruttoDiffTable.vue?vue&type=script&lang=js"
export * from "./BruttoDiffTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports